import ApiResource from '@/resource/ApiResource.js'
import Resource from '@/resource/Resource.js'
import User from '@/entities/User.js'

const resource = (function(){
	if(!import.meta.env.VITE_API_URL){
		throw new Error("Please add VITE_API_URL in .env file")
	}
	if(!import.meta.env.VITE_API_PREFIX){
		throw new Error("Please add VITE_API_PREFIX in .env file")
	}
	if(!import.meta.env.VITE_API_AUTH_PREFIX){
		throw new Error("Please add VITE_API_AUTH_PREFIX in .env file")
	}

	return new Resource(
		new ApiResource(
			User.getInstance(),
			import.meta.env.VITE_API_URL,
			import.meta.env.VITE_API_PREFIX,
			import.meta.env.VITE_API_AUTH_PREFIX
		)
	);
})();
export default resource;